import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AnnouncementBarComponent } from './announcement-bar.component';
import { AnnouncementBarService } from './announcement-bar.service';

@NgModule({
  declarations: [
    AnnouncementBarComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    AnnouncementBarComponent
  ],
  providers: [
    AnnouncementBarService
  ]
})
export class AnnouncementBarModule { }
